import { render, staticRenderFns } from "./CoresModal.vue?vue&type=template&id=e420826e&scoped=true"
import script from "./CoresModal.vue?vue&type=script&lang=js"
export * from "./CoresModal.vue?vue&type=script&lang=js"
import style0 from "./CoresModal.vue?vue&type=style&index=0&id=e420826e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e420826e",
  null
  
)

export default component.exports